/* Figma draws the background at the frame's own 430x940, pinned to the screen's
 * top-left (36:62 is absolutely positioned with TOP/LEFT constraints) and
 * clipped by it.
 *
 * It is not a stretched fill, and it must not become one: the composition is
 * built on two circles, and anything that scales the box unevenly turns them
 * into ellipses. So the size here is fixed in design pixels — a screen narrower
 * or shorter than the frame crops the background rather than squeezing it. The
 * `--u` scale is the only thing that ever resizes it, and that resizes
 * everything on the page together. */
.backdrop {
  position: absolute;
  top: 0;
  left: 0;

  width: calc(var(--frame-width) * var(--u));
  height: calc(var(--frame-height) * var(--u));
}
